export default function Trust() {
  const industries = [
    {
      icon: 'ri-scales-3-line',
      label: 'Law Firms'
    },
    {
      icon: 'ri-calculator-line',
      label: 'CPA / Accounting'
    },
    {
      icon: 'ri-heart-pulse-line',
      label: 'Healthcare Practices'
    },
    {
      icon: 'ri-leaf-line',
      label: 'Medspas'
    },
    {
      icon: 'ri-home-gear-line',
      label: 'Home Services'
    }
  ];

  return (
    <section id="industries" className="py-28 bg-[#FAFAFA] dark:bg-[#0e1b2c] transition-colors duration-300">
      <div className="max-w-[980px] mx-auto px-8">
        <h2 className="text-[56px] font-extralight text-center tracking-[-0.015em] text-[#0E1A2B] dark:text-[#e8edf4] mb-4">
          Built for High-Responsibility Industries
        </h2>
        
        <p className="text-[21px] font-light text-center tracking-[-0.01em] text-[#5C6675] dark:text-[#8899aa] max-w-[680px] mx-auto mb-20">
          We focus on industries where operational precision, compliance awareness, and client experience matter most.
        </p>

        <div className="flex items-center justify-center gap-16">
          {industries.map((industry, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center gap-3 transition-all duration-300 hover:opacity-60 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className={`${industry.icon} text-[48px] text-[#0E1A2B] dark:text-[#28D7C6]`}></i>
              </div>
              <span className="text-[15px] font-normal text-[#5C6675] dark:text-[#8899aa] text-center tracking-[-0.01em]">
                {industry.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}